export default __webpack_public_path__ + "static/media/Japri.03740a7c.png";